import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

export default class IconFooter extends Component {
  // constructor(props) {
  //   super(props);
  // }
  static propTypes = {
    image: PropTypes.string,
    isSmall: PropTypes.bool,
    isActive: PropTypes.bool
  };
  static defaultProps = {
    isSmall: false,
    isActive: false
  };

  onClick = () => {
    const { isActive } = this.props;
    if (isActive) {
      this.props.onClick();
    }
  };

  render() {
    const { image, isSmall, isActive } = this.props;
    return (
      <Wrapper
        image={image}
        isSmall={isSmall}
        isActive={isActive}
        onClick={this.onClick}
      />
    );
  }
}

const Wrapper = styled.div`
  flex: none;
  display: inline-flex;
  vertical-align: top;
  align-items: flex-end;
  justify-content: flex-end;
  width: 56.36px;
  height: 56.36px;
  background-color: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  ${props =>
    props.image &&
    css`
      background-image: url(${props.image});
    `};
  ${props =>
    props.isSmall &&
    css`
      width: 90%;
      height: 90%;
    `};
  ${props =>
    props.isActive &&
    css`
      opacity: 1;
      filter: alpha(opacity=100);
    `};
  ${props =>
    !props.isActive &&
    css`
      opacity: 0.5;
      filter: alpha(opacity=50);
    `};
`;



// WEBPACK FOOTER //
// ./src/module-common/IconFooter.js